import React, { useState } from "react";
import ApplicantRegisterManual from "./ApplicantRegisterManual";
import TradeBrochureModal from "./TradeBrochureModal";
import { useTradeGoogleTagManager } from "../../../../utils/tradeGoogleTagManager";

export default function TradeRegister() {
  useTradeGoogleTagManager();
  const [brochureModalOpen, setBrochureModalOpen] = useState(false);

  return (
    <>
      <ApplicantRegisterManual
        applicationScope="trade"
        learnerFlag
        loginRoute="/trade-login"
        registerTitle="Trade Performance Centre Registration"
        welcomeText="Trade Performance Centre"
        passwordPlaceholder="Create your password"
      />

      <button
        type="button"
        onClick={() => setBrochureModalOpen(true)}
        style={{
          position: "fixed",
          right: "24px",
          bottom: "24px",
          zIndex: 9000,
          border: 0,
          borderRadius: "999px",
          padding: "14px 22px",
          color: "#ffffff",
          background: "#f6aa2a",
          fontSize: "14px",
          fontWeight: 700,
          cursor: "pointer",
          boxShadow: "0 14px 28px rgba(246, 170, 42, 0.35)",
        }}
      >
        Download the brochure
      </button>

      <TradeBrochureModal
        open={brochureModalOpen}
        onClose={() => setBrochureModalOpen(false)}
      />
    </>
  );
}
